export const TIMELINE_PHASES = {
  PROVIDER_PENDING: 'provider-pending',
  PROVIDER_ASSIGNED: 'provider-assigned',
  SERVICE_SCHEDULED: 'service-scheduled',
  COMPLETED: 'completed',
} as const

export type TimelinePhase = (typeof TIMELINE_PHASES)[keyof typeof TIMELINE_PHASES]
